import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MarketingApp from "./MarketingApp";
import CmsAdminApp from "./cms/CmsAdminApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/cmsadmin/*" element={<CmsAdminApp />} />
        <Route path="*" element={<MarketingApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
